<div class="wl-app-workspace-container">
  <wl-dialog></wl-dialog>
  <router-outlet></router-outlet>
</div>
